import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@components/@core/Avatar';
import { convertUrl } from '~/services/util';

const CertificationInfo = ({ title, icon, description }) => (
    <div className="cert-info h-100 pb-5 ssp-b-0">
        <div className="header">
            <span className="dsl-b22 bold">{title}</span>
        </div>
        <div className="cert-user-content d-flex ssm-column ai-center">
            <div className="avatar-container">
                <Avatar type="logo" size="large" icon="fas fa-certificate" />
            </div>
            <div className="pl-4 ssp-l-0 mt-0 ssm-t-4">
                <p className="dsl-b14">{description}</p>
            </div>
        </div>
    </div>
);

CertificationInfo.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    description: PropTypes.string,
};

CertificationInfo.defaultProps = {
    title: '',
    icon: '',
    description: '',
};

export default memo(CertificationInfo);
